import React from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import checkPermission from '../../../Components/Hooks/PermissionHook';
function TableMoveButton({onClick, allowedPermission}) {
  const selectRoutePath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectRoutePath);
  
  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), allowedPermission)) {
    return (
      <button className="btn btn-ghost-info" onClick={onClick}>
        <svg className="me-1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="13" height="13" viewBox="0 0 13 13">
          <defs>
            <rect id="Rectangle_22" data-name="Rectangle 22" width="13" height="13" transform="translate(0 0)" fill="#030541" />
          </defs>
          <g id="Group_40" data-name="Group 40" transform="translate(0 0)">
            <g id="Group_40-2" data-name="Group 40" transform="translate(0 0)">
              <path id="Path_28" data-name="Path 28" d="M5.793,10.572V8.728a.666.666,0,0,1,.2-.49.69.69,0,0,1,.507-.2.656.656,0,0,1,.5.2.684.684,0,0,1,.192.49v1.844l.645-.615a.67.67,0,0,1,.493-.184.714.714,0,0,1,.506.186.7.7,0,0,1,.2.515.645.645,0,0,1-.2.5L7.007,12.8A.687.687,0,0,1,6.5,13a.637.637,0,0,1-.492-.2L4.164,10.972a.687.687,0,0,1-.2-.507.682.682,0,0,1,.7-.691.733.733,0,0,1,.51.184ZM2.428,7.191l.522.553a.693.693,0,0,1,.2.508.661.661,0,0,1-.7.691.673.673,0,0,1-.5-.184L.2,6.992A.637.637,0,0,1,0,6.5a.687.687,0,0,1,.2-.507L1.967,4.226a.66.66,0,0,1,.5-.2.694.694,0,0,1,.512.2.715.715,0,0,1,.184.5.733.733,0,0,1-.184.51l-.553.569H4.272A.691.691,0,0,1,4.757,6a.648.648,0,0,1,.207.5.664.664,0,0,1-.2.5.681.681,0,0,1-.492.192Zm8.16,0H8.759a.7.7,0,0,1-.5-.2A.655.655,0,0,1,8.052,6.5a.667.667,0,0,1,.2-.493.69.69,0,0,1,.505-.2h1.829l-.538-.553a.693.693,0,0,1-.2-.508.682.682,0,0,1,.2-.506.65.65,0,0,1,.5-.2.7.7,0,0,1,.513.2l1.752,1.752A.718.718,0,0,1,13,6.5a.664.664,0,0,1-.184.492L11.048,8.759a.662.662,0,0,1-.507.192.691.691,0,0,1-.492-.192.731.731,0,0,1-.223-.515.611.611,0,0,1,.223-.5ZM5.793,2.413l-.538.538a.653.653,0,0,1-.5.215.7.7,0,0,1-.515-.215.684.684,0,0,1-.2-.5.674.674,0,0,1,.215-.51L6.008.184A.664.664,0,0,1,6.5,0a.718.718,0,0,1,.507.184L8.759,1.936a.7.7,0,0,1,.2.515.647.647,0,0,1-.2.5.684.684,0,0,1-.5.2.7.7,0,0,1-.51-.2l-.553-.538V4.241A.7.7,0,0,1,7,4.746a.664.664,0,0,1-.5.2.68.68,0,0,1-.5-.2.69.69,0,0,1-.2-.505Z" transform="translate(0 0)" fill="#030541" />
            </g>
          </g>
        </svg>
        Move
      </button>
    )
  } else {
    return null;
  }

}

export default TableMoveButton
